import React, { useEffect, useRef, useState } from "react"
import { GlobalStyles } from "twin.macro"
import { useInView } from "react-intersection-observer"
import Header from "@structure/Header"
import Footer from "@structure/Footer"
import RarTab from "@components/RarTab"
import Gtm from "@components/Gtm"
import Isi from "@components/isi/Isi"
import IsiSticky from "@components/isi/IsiSticky"
import { DynamicIsiHook } from "@utils/DynamicIsiTriggers"

import tw from "twin.macro"

const Layout = ({
  children,
  stickyMenu,
  location,
  headerTheme,
  layoutHeaderRef,
  legalPage,
  ...rest
}) => {
  const headerRef = useRef(null)
  const isiStickyRef = useRef(null)
  const [stickyIsiMaxHeight, setStickyIsiMaxHeight] = useState(0)
  const [isiRef, inViewIsi] = useInView({ threshold: 0.03 })
  const [footerRef, inViewFooter] = useInView({ threshold: 0 })

  const [hideStickyIsi, sethideStickyIsi] = useState(true)

  const isHome = location?.pathname === "/"

  useEffect(() => {
    if (location?.search.includes("ed=1")) {
      document.body.setAttribute("data-screenshot-mode", "true")
      if (
        location?.search.includes("cookieBanner=1") ||
        location?.search.includes("cookieCenter=1")
      ) {
        setTimeout(() => {
          document.body.removeAttribute("style")
          document.documentElement.removeAttribute("style")
          document.body.style["overflowY"] = "auto"
          document.documentElement.style["overflowY"] = "auto"
          document.body.style["overflowX"] = "hidden"
          document.documentElement.style["overflowX"] = "hidden"
        }, 2000)
      }
    }
  }, [location?.search])

  useEffect(() => {
    if (inViewIsi || inViewFooter) {
      sethideStickyIsi(true)
    } else {
      sethideStickyIsi(false)
    }
  }, [inViewFooter, inViewIsi])

  useEffect(() => {
    //to ensure there is always consent initialization
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "gtm.init_consent",
    })
  }, [])

  // dynamic ISI
  const scrollTo = DynamicIsiHook(location)

  return (
    <div {...rest} css={[!isHome && tw`relative flex flex-col min-h-screen`]}>
      <GlobalStyles />
      <Gtm />
      <Header
        sticky={stickyMenu}
        location={location}
        headerRef={headerRef}
        colorTheme={headerTheme}
        legalPage={legalPage}
      />
      <main id="main-content">
        {children}
        <RarTab location={location} stickyIsiMaxHeight={stickyIsiMaxHeight} />
        <div ref={isiRef}>
          <Isi location={location} headerRef={headerRef} />
        </div>
      </main>
      <div>
        <IsiSticky
          stickyIsiMaxHeight={stickyIsiMaxHeight}
          setStickyIsiMaxHeight={setStickyIsiMaxHeight}
          isiStickyRef={isiStickyRef}
          headerRef={headerRef}
          hide={hideStickyIsi}
          location={location}
          scrollTo={scrollTo}
        />
      </div>
      <div ref={footerRef}>
        <Footer tw="mt-auto" />
      </div>
    </div>
  )
}
export default Layout
